module.exports = __webpack_public_path__ + "img/sakuya izayoi scarlet_lw.6ce1bac4.png";